import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip'

export const TooltipProvider = BaseTooltip.Provider
